import { Link, useParams } from "react-router-dom";
import { useApp } from "../../../context/AppContext";

//import resources
import { FaPlus } from "react-icons/fa";

//import tags
import { Accordion, AccordionItem } from '@szhsin/react-accordion';

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Categories() {

    const { categories } = useApp();

    //import locales
    const { locale, slug } = useParams();
    const { t } = useTranslation();

    return (
        
        <div className="border bordar-gray-200 rounded-xl p-5">
            <div className="pb-3 border-b upper font-bold text-lg">{t('categories')}</div>
            {
                typeof categories === 'object' && categories != null ? 
                    categories.data.map((item) => {
                        return(
                            <Accordion key={item.id}>
                                <AccordionItem 
                                    header={
                                        <div className="flex items-center justify-between w-full text-[15px]">
                                            <Link className={`${slug === item.slug ? 'text-[var(--orange)]' : ''}`} onClick={(e) => e.stopPropagation()} to={`/${locale}/products/${item.slug || ""}`}>{item.translations[0]?.name}</Link> <FaPlus />
                                        </div>
                                    } 
                                    initialEntered={item.descendants.some(descendant => descendant.slug === slug)}
                                >
                                    {
                                        item.descendants.length > 0 ?
                                            <ul className="children mt-3">
                                                {
                                                    item.descendants.map((descendant) => {
                                                        return(
                                                            <li>
                                                                <Link className={`text-[13px] ${slug === descendant.slug ? 'text-[var(--orange)]' : ''}`} to={`/${locale}/products/${descendant.slug || ""}`}>{descendant.name}</Link>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                        :
                                        ''
                                    }
                                    
                                </AccordionItem>
                            </Accordion>
                        );   
                    })
                    
                :
                ''
            }
            
        </div>
        
    );
}